import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Row, Col } from "reactstrap";
import LottieLoader from '../../LottieLoader';
import lottieEmptyFile from '../../../files/animation/empty_new.json';
import LACERiskScoreModal from '../LACERiskScoreModal';
import { useFetch2 } from "components/utils/authenticatedHook";
import encryptRequest from "../../../helpers/encryptationHelper";
import lottieLoaderFile from '../../../files/animation/loading.json';
import moment from "moment";
import Swal from "sweetalert2";
import { connect } from "react-redux";

const LACERiskScore = (props) => {
  const [{ response, error, isLoading }, doFetch, sendError] = useFetch2(null);
  const [{ response: getLaceScores, error: getLaceScoresError, isLoading: getLaceScoresLoading }, doFetch2] = useFetch2(null);
  const [{ response: deleteLaceScore, error: deleteLaceScoresError, isLoading: deleteLaceScoresLoading }, doFetch3] = useFetch2(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [editId, setEditId] = useState(null);

  const handleSubmit = (data) => {
    if (props && props.patient) {
      const payload = {
        patientId: props.patient._id,
        submissions: data.questions,
        createdBy: props.userId,
        totalScore: data.totalScore
      }
      doFetch({
        url: "/save-lace-risk-score",
        method: "POST",
        disableWait: true,
        body: payload
      });
      setIsSubmitted(true);
    }
  }

  useEffect(() => {
    if ((!isLoading && !deleteLaceScoresLoading) && isSubmitted) {
      fetchLaceScores();
      setIsSubmitted(false);
      props.dispatch({
        type: "DO_GET_PROFILE_PATIENT",
        payload: { user: props.patient._id, timeZone: moment.tz.guess() }
      });
    }
  }, [isLoading, deleteLaceScoresLoading])

  function toCapitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handleEdit = (data, id) => {
    doFetch({
      url: "/update-lace-risk-score",
      method: "PUT",
      disableWait: true,
      body: { id, submissions: data.questions, totalScore: data.totalScore, lastModifyBy: props.userId }
    });
    setIsSubmitted(true);
  };

  const handleDelete = (id) => {
    if (id) {
      doFetch({
        url: "/delete-lace-risk-score/" + encryptRequest(id),
        method: "DELETE",
        disableWait: true,
      });
      setIsSubmitted(true);
    }
  };


  const columns = [
    {
      dataField: "createdAt",
      text: "Created Date",
      sort: true,
      formatter: (cell) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '40px' }}>
          <p style={{ margin: 0, textAlign: 'center' }}>
            {cell ? moment(cell).format("MMMM DD, YYYY hh:mm A") : "-"}
          </p>
        </div>
      ),
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' }
    },
    {
      dataField: "totalScore",
      text: "Points",
      sort: true,
      formatter: (cell) => {
        let risk = '';
        let badgeStyle = {};
        if (cell <= 4) {
          risk = 'Low';
          badgeStyle = { backgroundColor: '#28a745', color: '#fff' };
        } else if (cell <= 9) {
          risk = 'Moderate';
          badgeStyle = { backgroundColor: '#ffc107', color: '#212529' };
        } else {
          risk = 'High';
          badgeStyle = { backgroundColor: '#dc3545', color: '#fff' };
        }
        return (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
            <p style={{ margin: 0, fontWeight: 'bold' }}>{cell}</p>
            <span
              style={{
                ...badgeStyle,
                padding: '4px 8px',
                borderRadius: '12px',
                fontSize: '0.75rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                border: '1px solid rgba(255,255,255,0.2)'
              }}
            >
              {risk}
            </span>
          </div>
        )
      },
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' }
    },
    {
      dataField: "createdBy",
      text: "Created By",
      sort: true,
      formatter: (cell, row) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '40px' }}>
          <p style={{ margin: 0, textAlign: 'center' }}>
            {!row.createdBy ? "-" : `${toCapitalize(row.createdBy.lname)} ${toCapitalize(row.createdBy.fname)}`}
          </p>
        </div>
      ),
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' }
    },
    {
      dataField: "modifyDate",
      text: "Last Modify Date",
      sort: true,
      formatter: (cell, row) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '40px', textAlign: 'start' }}>
          <p style={{ margin: 0, fontSize: '14px' }}>
            {cell && row.lastModifyBy ? `${moment(cell).format("MMMM DD, YYYY hh:mm A")}` : "-"}
          </p>
        </div>
      ),
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' }
    },
     {
      dataField: "modifyDate",
      text: "Last Modify By",
      sort: false,
      formatter: (cell, row) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '40px', textAlign: 'start' }}>
          <p style={{ margin: 0, fontSize: '14px' }}>
            {cell && row.lastModifyBy ? `${row.lastModifyBy ? `${toCapitalize(row.lastModifyBy.lname)} ${toCapitalize(row.lastModifyBy.fname)}` : ''}` : "-"}
          </p>
        </div>
      ),
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' }
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (cell, row) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '40px', gap: '5px' }}>
          <button
            className="btn btn-sm"
            style={{ borderRadius: "8px", background: '#007bff', color: 'white', padding: '4px 8px' }}
            onClick={() => { setViewData(row); setEditId(row._id); setModalOpen(true); }}
            title="View"
          >
            <i
              className="mdi mdi-eye"
              style={{ fontSize: "15px", color: 'white' }}
            /> VIEW
          </button>
          <button
            className="btn btn-sm"
            style={{ borderRadius: "8px", background: '#d33', color: 'white', padding: '4px 8px' }}
            onClick={() =>
              Swal.fire({
                title: "Are you sure?",
                text: "You want to delete this LACE risk score?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
              }).then((result) => {
                if (result.isConfirmed) {
                  handleDelete(row?._id);
                }
              })
            }
            title="Deactivate"
          >
            <i
              className="mdi mdi-close"
              style={{ fontSize: "15px", color: 'white' }}
            /> DELETE
          </button>
        </div>
      ),
      headerStyle: { width: '11%', textAlign: 'center' },
      style: { textAlign: 'center' }
    }
  ];

  const NoDataIndication = () => (
    <div>
      {(getLaceScoresLoading || isLoading) ? (
        <LottieLoader
          loadLoop={true}
          autoplayLoop={true}
          source={lottieLoaderFile}
          Lheight={150}
          Lwidth={150}
          subTitle={"Please Wait ..."}
        />
      ) : (
        <LottieLoader
          loadLoop={false}
          autoplayLoop={true}
          source={lottieEmptyFile}
          Lheight={300}
          Lwidth={300}
          title={"Sorry! No LACE Risk Score found."}
        />
      )}
    </div>
  );

  const fetchLaceScores = () => {
    if (props && props.patient) {
      doFetch2({
        url: "/get-lace-risk-score/" + encryptRequest(props.patient._id),
        method: "GET",
        disableWait: true
      });
    }
  }

  useEffect(() => {
    fetchLaceScores();
  }, []);

  return (
    <div className="container-fluid p-2" style={{ backgroundColor: '#ffffffff', marginTop: 4 }}>
      <Row className="mb-2">
        <Col xs="12" className="text-center text-md-right">
          <button
            className="text-white float-right btn btn-info btn-icon-text create-note-click-cls"
            style={{ margin: 3 }}
            onClick={() => setModalOpen(true)}
          >
            <i className="mdi mdi-clipboard-plus"> </i> &nbsp; NEW LACE RISK SCORE
          </button>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12}>
          <div className="shadow-sm" style={{ borderRadius: '5px', overflowX: "auto", width: "100%" }}>
            <BootstrapTable
              keyField="_id"
              data={getLaceScores && !getLaceScoresLoading && !isLoading ? getLaceScores.data : []}
              columns={columns}
              condensed
              responsive={true}
              wrapperClasses=""
              noDataIndication={NoDataIndication}
            />
          </div>
        </Col>
      </Row>
      {modalOpen && (<LACERiskScoreModal
        isOpen={modalOpen}
        toggle={() => { setModalOpen(!modalOpen); setViewData(null); setEditId(null); }}
        onSubmit={handleSubmit}
        onEdit={handleEdit}
        viewDetails={viewData}
        editId={editId}
      />)}
    </div>
  );
};

const mapStateToProps = ({ user }) => {
  const profile = user.profile;
  return {
    profile,
  };
};

export default connect(mapStateToProps)(LACERiskScore)